module.exports = __webpack_public_path__ + "img/nft-monkey.fd73f9f.png";